<template>
    <div>
        <!-- <DialogoFotosPre ref="dialogoPreFotos" @cargadaFoto="cargaFotoCam" titulo="Foto Carnet"></DialogoFotosPre> -->
        <DialogoFotos ref="dialogoPreFotos"></DialogoFotos>
        <v-list>
            <v-list-item-group v-model="selectedItem" mandatory :color="(!hayFotoCarnet) ? 'primary' : 'green'"
                @change="descartaFoto">
                <v-overlay v-model="overlay" :absolute="true">
                    <v-btn color="warning" class="pa-6 elevation-0" @click="onClearFileInput">
                        <v-icon class="mr-2">
                            mdi-delete-outline
                        </v-icon>
                        Actualizar datos guardados
                    </v-btn>
                </v-overlay>
                <v-list-item @click="handleFileImport">
                    <v-list-item-icon>
                        <input ref="uploader" class="d-none" type="file" accept="image/jpeg,image/jpg"
                            @change="onFileChanged">
                        <v-icon>mdi-folder-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>SUBIR ARCHIVO</v-list-item-title>
                    </v-list-item-content>
                    <!--  <canvas id="canvas" width="600" ref="canvas" style="display: none"></canvas> -->
                    <v-list-item-action>
                        <v-icon v-if="selectedItem == 0 && hayFotoCarnet">mdi-check-circle</v-icon>
                        <v-icon v-if="!hayFotoCarnet">mdi-arrow-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item @click="lanzarDialogFoto" v-if="$vuetify.breakpoint.mdAndUp">
                    <v-list-item-icon>
                        <v-icon>mdi-webcam</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>TOMAR FOTO</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon v-if="selectedItem == 1 && hayFotoCarnet">mdi-check-circle</v-icon>
                        <v-icon v-if="!hayFotoCarnet">mdi-arrow-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list-item-group>
            <v-col class="d-flex flex justify-center" v-if="fototmp">
                <canvas width="0" ref="canvas"></canvas>
            </v-col>
        </v-list>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex'
import InputButton from '@/components/inputs/InputButton.vue'
import CameraCanvas from '@/components/inputs/CameraCanvas.vue'
import DialogoFotos from '@/components/dialogos/DialogoFotos.vue'


export default {
    components: {
        InputButton,
        CameraCanvas,
        DialogoFotos,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            // subir archivos
            file: null,
            selectedFile: null,
            selectedFileName: '',
            activeCamera: false,
            //data select
            selectedItem: null,
            overlay: false,
            isSelecting: false,

            elem: 0,
        }
    },
    computed: {
        ...mapGetters('preafiliacion', ['fototmp', 'preafi', 'hayFotoCarnet', 'fotocarnet']),
        ...mapGetters('auth', ['isAuthenticated'])
    },

    methods: {
        ...mapActions('preafiliacion', ['addFotoCarnet', 'deleteFotoCarnet']),
        ...mapActions('notificaciones', ['showSnack']),

        descartaFoto() {
            this.addFotoCarnet('')

        },
        cargaFotoCam(value) {
            this.overlay = true
            console.log(value)
            // emite a ExpansionPanelGen
            this.$emit('isCorrectForm', { valid: true, index: this.index })
        },

        /*  Metodos para 'subir archivo' */
        handleFileImport() {
            this.isSelecting = true

            // After obtaining the focus when closing the FilePicker, return the button state to normal
            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });

            // Trigger click on the FileInput
            try {
                this.$refs.uploader.click();
            } catch (error) {
                this.isSelecting = false
            }
        },
        archivoPermitido(type) {
            // archivos permitidos (jpeg/jpg/png/docX/pdf/tiff/jfif)
            //,.jpg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document	
            //console.log("tipo Archivo -> " + archivo.type);
            //console.log("Archivo -> " + archivo.name);
            switch (type) {
                case "image/png":
                case "image/jpg":
                case "image/jpeg":
                case "application/pdf":
                    break;
                default:
                    return false
                /*                     msg = "Error: El tipo de Archivo NO está permitido!. Permitidos (jpeg/jpg/png/pdf)."; */
            }
            return true
        },
        onFileChanged(e) {
            if (e.target.files[0]) {
                this.selectedFile = e.target.files[0]
                const maxAllowedSize = 5 * 1024 * 1024
                const permitido = this.archivoPermitido(this.selectedFile.type)

                if ((this.selectedFile.size < maxAllowedSize) && (permitido)) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        //referencia al elemento canvas
                        let canvas = this.$refs.canvas

                        const ctx = canvas.getContext('2d')

                        //config
                        const vm = this

                        //nueva imagen
                        const img = new Image

                        img.src = URL.createObjectURL(this.selectedFile)
                        img.onload = function () {
                            const targetWidth = 600;
                            const targetHeight = 450;
                            let newWidth, newHeight;
                            if (img.width / img.height > targetWidth / targetHeight) {
                                newWidth = img.width * (targetHeight / img.height);
                                newHeight = targetHeight;
                            } else {
                                newWidth = targetWidth;
                                newHeight = img.height * (targetWidth / img.width);
                            }
                            // Calcula los desplazamientos para recortar desde el centro
                            const offsetX = (newWidth - targetWidth) / 2;
                            const offsetY = (newHeight - targetHeight) / 2;
                            // Asigna las nuevas dimensiones al canvas
                            canvas.width = targetWidth;
                            canvas.height = targetHeight;

                            ctx.clearRect(0, 0, canvas.width, canvas.height)
                            ctx.drawImage(img, -offsetX, -offsetY, newWidth, newHeight);

                            let dataURL = canvas.toDataURL('image/png');
                            const arr = dataURL.split(',');
                            this.addFotoCarnet(arr[1])
                            vm.elem = 1
                        }
                    };
                    reader.readAsDataURL(this.selectedFile)
                } else {
                    this.showSnack({
                        type: '400',
                        message: 'archivo no permitido. Debe ser menor a 5MB y en formato .pdf, .jpg, .jpeg o .png'
                    })
                }
            }

        },


        /*   onFileChanged(e) {
              this.selectedFile = ''
              if (e.target.files[0]) {
                  this.selectedFile = e.target.files[0]
                  console.log(this.selectedFile)
                  this.selectedFileName = e.target.files[0].name
                  //this.precargaFoto(this.selectedFile)
  
                  //envio señal de fotoSeleccionada
                  //this.$emit('haySeleccion')
                  const reader = new FileReader();
                  reader.onloadend = () => {
                      //referencia al elemento canvas
                      let canvas = this.$refs.canvas
                      //config
                      const ctx = canvas.getContext("2d");
                      //nueva imagen
                      const img = new Image
                      img.src = URL.createObjectURL(this.selectedFile)
                      img.onload = function () {
                          var hRatio = canvas.width / img.naturalWidth
                          var vRatio = canvas.height / img.naturalHeight
                          var ratio = Math.min(hRatio, vRatio)
  
                          var centerX = (canvas.width - img.width * ratio) / 2
  
                          //REVISAR: aca esta el problema, esta dando 0
                          var centerY = (canvas.height - img.height * ratio) / 2
  
                          ctx.clearRect(0, 0, canvas.width, canvas.height)
  
                          //ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
                          ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
  
                      }
                      let dataURL = canvas.toDataURL('image/png');
                      console.log(dataURL)
                      const arr = dataURL.split(',');
                      console.log(dataURL)
                      this.addFotoCarnet(arr[1])
                      this.showSnack({
                          message: 'Archivo guardado correctamente',
                          type: '200'
                      })
                  };
                  reader.readAsDataURL(this.selectedFile)
                  this.overlay = true
                  // emite a ExpansionPanelGen
                  this.$emit('isCorrectForm', { valid: true, index: this.index })
              }
          }, */
        /*  Fin metodos 'subir archivo' */

        changedValue() {
            this.selectedItem = -1
        },
        onClearFileInput() {
            this.deleteFotoCarnet()
            this.overlay = false
        },

        /* Metodos para 'tomar foto' */
        lanzarDialogFoto() {
            this.$refs.dialogoPreFotos.abrirDialogo()
        }
        /* Fin metodos 'tomar foto' */

    },
    props: ['index'],

}


</script>